var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AuthLayout,
    [
      _c(_setup.AuthCardHeader, { attrs: { title: _setup.title } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-complete" },
        [
          !_setup.error && !_setup.slow
            ? _c("b-spinner")
            : _setup.error
            ? _c(_setup.CError, { attrs: { message: _setup.error } })
            : _c("p", { staticClass: "signup-complete-slow" }, [
                _vm._v(
                  "\n            Your checkout is complete and we're finishing setting up your account. This usually takes a minute:\n            click Check again, or log in a little later.\n        "
                ),
              ]),
          _vm._v(" "),
          _setup.error || _setup.slow
            ? _c(
                "div",
                {
                  staticClass: "signup-complete-actions",
                  class: { "single-action": !_setup.slow },
                },
                [
                  _setup.slow
                    ? _c(_setup.CButton, {
                        attrs: {
                          variant: "outline-primary",
                          text: "Check again",
                        },
                        on: { click: _setup.checkAgain },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { href: "/signin" },
                    },
                    [_vm._v("Go to log in")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }